export default {
  viewBox: "0 0 16 16",
  html: "<path fill=\"#fff\" fill-rule=\"evenodd\" d=\"M7.646 5.146a.5.5 0 0 1 .708 0l5 5a.5.5 0 0 1-.708.708L8 6.207l-4.646 4.647a.5.5 0 0 1-.708-.708z\" clip-rule=\"evenodd\"/>"
};